module.exports = __webpack_public_path__ + "static/media/volume.a44daf52.svg";